<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
  name: "PostaBase"
};
</script>

<style scoped>

</style>
